import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Chip } from '@material-ui/core';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { SubEntityCustomListCard } from './SubEntityCustomListCard';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { SubEntityList } from '../../common/components/SubEntity/SubEntityList';

const queryString = require('query-string');
export class Venue extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'Venue'
    this.pageTitle = Helper.getString('venueDetails')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.deviceId = this.props.match.params.id
    this.query = queryString.parse(props.location.search);
    if (this.orgId === 'PRODUCT') {
      // For BO
      this.toFetch = [
        { method: 'GET', paths: ['devices', this.deviceId], queryParams: { orgId: this.orgId, pb: 'fieldDef' } },
        { method: 'GET', paths: ['playlists'], queryParams: { iType: 'DEFAULT' } },
        { method: 'GET', paths: ['miscs', 'orgfastlistall'],  queryParams: { state: 'LIVE' } },
        { method: 'GET', paths: ['miscs', 'campaigns'], queryParams: { groupId: 'PRODUCT', state: 'LIVE', pb: 'fieldDef', limit: 1500 } },
        { method: 'GET', paths: ['devicetags'], queryParams: { groupId: 'PRODUCT', pb: 'fieldDef', limit: 1000 } },
        { method: 'GET', paths: ['venuegroups'], queryParams: { groupId: 'PRODUCT' } },
        { method: 'GET', paths: ['miscs', 'layouts'], queryParams: { orgId: 'PRODUCT', state: 'LIVE', layoutType: 'SL' } },
        {
          method: 'GET', paths: ['miscs', 'devicesearchdb'],
          queryParams: { facets: [], pb: 'fieldDef,fieldDefInstallation,fieldDefVenueGen,fieldDefVenueInfo,fieldDefDeviceLogo', state: this.defaultState }
        },
        { method: 'GET', paths: ['items'], queryParams: { groupId: 'restrictiontag' + this.orgId, pb: 'fieldDef', limit: 1000 } },
        { method: 'GET', paths: ['miscs', 'devicehistory'], queryParams: { deviceId: this.deviceId } }
      ]
    } else {
      // For partner Site, NON BO
      this.toFetch = [
        { method: 'GET', paths: ['devices', this.deviceId], queryParams: { orgId: this.orgId, pb: 'fieldDef' } },
        { method: 'GET', paths: ['items'], queryParams: { groupId: 'displayads' + this.orgId } },
        { method: 'GET', paths: ['items'], queryParams: { groupId: 'audioads' + this.orgId } },
        { method: 'GET', paths: ['campaigns'], queryParams: { groupId: this.orgId } },
        { method: 'GET', paths: ['devicetags'], queryParams: { groupId: this.orgId, pb: 'fieldDef' } },
        { method: 'GET', paths: ['orgs', this.orgId] },
        { method: 'GET', paths: ['devicecfs'], queryParams: { groupId: this.orgId, pb: 'fieldDefCfSuggestions' } },
        { method: 'GET', paths: ['miscs', 'venues-of-org'], queryParams: { orgId: this.orgId, pb: 'fieldDef' } },
        { method: 'GET', paths: ['miscs', 'devicehistory'], queryParams: { deviceId: this.deviceId } }
      ]
    }

    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Time: (current) => AppHelper.formatTimestamp(current.ts),
      'Who (userId)': (current) => current.userEmail,
      Action: (current) => <div className={css(Styles.commentStyle)}>{current.comment}</div>
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.allowAccessToRoles = ['SUPERUSER']
    this.noAdd = true
    this.noAddSubEntity = true
  }

  onFetchSuccess(results, options) {
    this.venueItem = results[0]
    this.pageTitle = this.venueItem.title
    this.mainFields = []
    // BreadCrumbs
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('venues'), to: this.baseRoute() + '/screens' },
      { title: this.venueItem.deviceCode },
    ]

    if (this.orgId === 'PRODUCT') {
      const venuesResult = results[6]
      this.orgType = venuesResult.groupId
      // Create BO Form Field
      this.formDefinition = results[0].fieldDef

      this.formDefinition.steps[0].fields = this.formDefinition.steps[0].fields.filter(f => {
        return !Helper.inArray([
          'audioAdId', 'audioAdIds', 'audioAdPartnerIds', 'imageAdId', 'imageAdIds', 'imageAdPartnerIds',
          'campaignsPartner', 'tagsPartner', 'venueGroups'
        ], f.key)
      })

      const sites = []
      const partners = []
      const pas = []
      const fas = []
      results[2].items.forEach(org => {
        if (org.groupId === 'PARTNER') {
          partners.push(org)
        } else if (org.groupId === 'SITE') {
          sites.push(org)
        } else if (org.groupId === 'PA') {
          pas.push(org)
        } else if (org.groupId === 'FA') {
          fas.push(org)
        }
      });

      UiHelper.populateOptions(this.formDefinition, results[1], 'playlists')
      UiHelper.populateOptions(this.formDefinition, results[3], 'campaigns')
      UiHelper.populateOptions(this.formDefinition, results[4], 'tagsBo')
      UiHelper.populateOptions(this.formDefinition, results[5], 'venueGroups')
      UiHelper.populateOptions(this.formDefinition, results[8], 'restrictionTags')
      UiHelper.populateOptions(this.formDefinition, { items: sites }, 'orgId')
      UiHelper.populateOptions(this.formDefinition, { items: partners }, 'partnerOrgId')
      UiHelper.populateOptions(this.formDefinition, { items: pas }, 'paOrgId')
      UiHelper.populateOptions(this.formDefinition, { items: fas }, 'faOrgId')
      this.formDefinition.steps[0].fields.map((x) => {
        if (x.type === 'check_box' && x.key === 'tagsBo') {
          x.addOptions = true
        }
        return x
      })
      this.setState({
        deviceHistory: results[9] || [],
      })

      const processVenue = AppHelper.processVenueItems([this.venueItem])
      this.generateInfoBo(processVenue[0])

    } else {

      const venuesResult = results[7]
      this.orgType = venuesResult.groupId
      this.formDefinition = results[0].fieldDef

      const fields = []
      this.formDefinition = { ...venuesResult.fieldDef, formId: 'venueEditForm' }
      if (this.options && this.options.pageForOrgType && this.options.pageForOrgType === 'PARTNER') {
        this.formDefinition.steps[0].fields = this.formDefinition.steps[0].fields.filter(x => x.key && x.key !== 'imageAdPartnerIds') // Display ads commented.
      }
      this.formDefinition.steps[0].fields.forEach(i => {
        if (Helper.inArray(['title', 'deviceCode'], i.key)) { // will be disabled
          fields.push(i)
        }
        if (this.orgType === 'PARTNER'
          && Helper.inArray(['imageAdPartnerIds', // TODO: deprecate
            'audioAdPartnerIds', 'campaignsPartner', 'tagsPartner', 'extId'], i.key)) {
          if (i.key === 'extId') i.placement = 'left'
          fields.push(i)
        }
        if (this.orgType === 'SITE'
          && Helper.inArray(['imageAdIds', 'audioAdIds'], i.key)) {
          fields.push(i)
        }
      })
      this.formDefinition.steps[0].fields.find(i => i.key === 'title').disabled = true
      this.formDefinition.steps[0].fields.find(i => i.key === 'deviceCode').disabled = true
      this.formDefinition.steps[0].fields = fields
      // Adding Custom Tag
      this.formDefinition.steps[0].fields.map((x) => {
        if (x.type === 'check_box' && x.key === 'tagsPartner') {
          x.addOptions = true
        }
      })


      UiHelper.populateOptions(this.formDefinition, results[1], 'imageAdIds')
      UiHelper.populateOptions(this.formDefinition, results[1], 'imageAdPartnerIds') // TODO: deprecate
      UiHelper.populateOptions(this.formDefinition, results[2], 'audioAdIds')
      UiHelper.populateOptions(this.formDefinition, results[2], 'audioAdPartnerIds')
      UiHelper.populateOptions(this.formDefinition, results[3], 'campaignsPartner') // TODO: enable campaignsPartner
      UiHelper.populateOptions(this.formDefinition, results[4], 'tagsPartner')
      this.setState({
        tags: results[4],
        deviceHistory: results[8] || [],
      }, () => {
        const processVenue = AppHelper.processVenueItems([this.venueItem])
        this.generateInfoNonBo(processVenue[0])
      })

    }

  }

  async onFormFieldOptionAdd(options) {
    const { formField, value, formId } = options
    if (!this.formDefinition || this.formDefinition.formId !== formId) return

    const isBo = this.orgId === 'PRODUCT'

    if (isBo && formField.key === 'tagsBo') {
      await ApiHelper.callAwait({
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['devicetags']),
        jsonBody: { groupId: 'PRODUCT', title: value }
      })
      const updatedResult = await ApiHelper.callAwait({
        method: 'GET',
        paths: ['devicetags'],
        queryParams: { groupId: 'PRODUCT', pb: 'fieldDef' }
      })
      this.formDefinition.steps[0].fields.map(x => {
        if (x.key === formField.key) {
          UiHelper.populateOptions(this.formDefinition, updatedResult, formField.key)
        }
        return x
      })
      return updatedResult || {}
    }

    if (!isBo && formField.key === 'tagsPartner') {
      await ApiHelper.callAwait({
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['devicetags']),
        jsonBody: { groupId: this.orgId, title: value }
      })
      const updatedResult = await ApiHelper.callAwait({
        method: 'GET',
        paths: ['devicetags'],
        queryParams: { groupId: this.orgId, pb: 'fieldDef' }
      })
      this.formDefinition.steps[0].fields.map(x => {
        if (x.key === formField.key) {
          UiHelper.populateOptions(this.formDefinition, updatedResult, formField.key)
        }
        return x
      })
      return updatedResult || {}
    }
  }

  generateInfoBo(current) {
    this.mainFields = []
    this.addSiteInfoFields(current)
    if (current.title) {
      this.mainFields.push({
        label: 'Title',
        value: current.title
      })
    }
    this.mainFields.push(
      {
        label: 'Device Code',
        value: current.deviceCode
      }
    )

    if (current.createdTs) {
      this.mainFields.push({ label: 'Creation Date', value: AppHelper.customFormatTimestamp(current.createdTs, 'YYYY-MM-DD') })
    }

    if (current.state === 'ARCHIVED') {
      this.mainFields.push({
        label: 'State',
        value: 'ARCHIVED'
      })
    }

    if (!current.installationId && !AppHelper.isNonApkDevice(current)) {
      this.mainFields.push({
        label: 'Registration',
        value: 'NOT REGISTERED'
      })
    }
    if (current.testing === 'YES') {
      this.mainFields.push({
        label: 'Testing',
        value: '(NOT SSP)'
      })
    }
    if (current.latestDeviceFeed && current.latestDeviceFeed.serialnumber && typeof current.latestDeviceFeed.serialnumber === 'string' && current.latestDeviceFeed.serialnumber.toLowerCase() !== 'unknown') {
      this.mainFields.push({
        label: 'SN',
        value: current.latestDeviceFeed.serialnumber
      })
    }
    if (current.extId) {
      this.mainFields.push({
        label: 'EXTID',
        value: current.extId
      })
    }
    // if(current.extId) {
    this.mainFields.push({
      label: 'VistarId',
      value: (current.info && (current.info.vistarId || current.info.title)) || '(no vistarId)'
    })
    // }
    if (current.info && current.info.address) {
      this.mainFields.push({
        label: 'Address',
        value: (current.info && current.info.address) || '(no address)'
      })
    }

    if (current._ORIENTATION) {
      this.mainFields.push({
        label: 'Orientation',
        value: current._ORIENTATION
      });
    }

    // this.mainFields.push({
    //   label: 'Screen Groups Count',
    //   value: (current.venueGroups || []).length
    // });

    if (current.orgId) {
      this.mainFields.push({
        label: 'Site',
        value: 'YES'
      });
    }

    if (current.partnerOrgId) {
      this.mainFields.push({
        label: 'Partner ',
        value: 'YES'
      });
    }

    if (current.paOrgId) {
      this.mainFields.push({
        label: 'PA',
        value: 'YES'
      });
    }

    if (current.faOrgId) {
      this.mainFields.push({
        label: 'FA',
        value: 'YES'
      });
    }

    if (current.imageName) {
      this.mainFields.push({
        label: 'Image',
        value: 'YES'
      });
    }

    this.mainFields.push({
      label: 'Disp Campaigns',
      value: (current.campaigns || []).length
    });

    this.mainFields.push({
      label: 'Audio Campaigns',
      value: (current.playlists || []).length
    });

    if (current.screenLayouts && current.screenLayouts.length > 0) {
      this.mainFields.push({
        label: 'Screen Layouts',
        value: `Screen Layouts (${current.screenLayouts.length})`
      });
    }

    const status = (current.latestDeviceFeed && current.latestDeviceFeed.currentTs) ?
      AppHelper.getVenueStatus(Helper.currentTs() - current.latestDeviceFeed.currentTs)
      : AppHelper.offlineStatus()
    if(status) {
      this.mainFields.push({
        label: 'Status',
        value: status || Helper.getString('unknown')
      });
    }

    if(AppUiHelper.getVenueSignalStatus(current)) {
      this.mainFields.push({
        label: 'Signal Status',
        value: AppUiHelper.getVenueSignalStatus(current) || Helper.getString('unknown')
      });
    }

    if(AppHelper.getHdmiInfo(current)) {
      this.mainFields.push({
        label: 'HDMI Info',
        value: AppHelper.getHdmiInfo(current) || Helper.getString('unknown')
      });
    }
  }

  generateInfoNonBo(current) {
    this.mainFields = []
    this.addSiteInfoFields(current)

    if (current.title) {
      this.mainFields.push({
        label: 'Title',
        value: current.title
      })
    }

    // VENUE FIELDS (LEFT COLUMN)
    if (current.deviceCode) {
      this.mainFields.push({ label: 'Device Code', value: current.deviceCode })
    }

    if (current.createdTs) {
      this.mainFields.push({ label: 'Creation Date', value: AppHelper.customFormatTimestamp(current.createdTs, 'YYYY-MM-DD') })
    }

    if (current.extId) {
      this.mainFields.push({ label: 'EXTID', value: current.extId })
    }

    if (
      current.latestDeviceFeed &&
      typeof current.latestDeviceFeed.serialnumber === 'string' &&
      current.latestDeviceFeed.serialnumber.toLowerCase() !== 'unknown'
    ) {
      this.mainFields.push({
        label: 'SN',
        value: current.latestDeviceFeed.serialnumber
      })
    }

    if (current.state === 'ARCHIVED') {
      this.mainFields.push({ label: 'State', value: 'ARCHIVED' })
    }

    if (!current.installationId && !AppHelper.isNonApkDevice(current)) {
      this.mainFields.push({ label: 'Registration', value: 'NOT REGISTERED' })
    }

    if (current.info && current.info.address) {
      this.mainFields.push({ label: 'Address', value: current.info.address })
    }

    // INFO FIELDS
    // (Active Time)
    if (current.latestDeviceFeed && current.latestDeviceFeed.currentTs) {
      this.mainFields.push({
        label: 'Active',
        value: AppHelper.formatActiveTime(Helper.currentTs() - current.latestDeviceFeed.currentTs)
      })
    } else {
      this.mainFields.push({
        label: 'Active',
        value: Helper.getString('unknown')
      })
    }

    // (App Version)
    if (!AppHelper.isNonApkDevice(current)) {
      let appVersion = Helper.getString('unknown')
      if (current.latestDeviceFeed && current.latestDeviceFeed.versionCode) {
        appVersion = `#${current.latestDeviceFeed.versionCode}`
      }
      this.mainFields.push({
        label: 'App',
        value: appVersion
      })
    }

    // (PARTNER ONLY) Audio Ads, Tags
    if (this.orgType === 'PARTNER') {
      this.mainFields.push({
        label: 'Audio Ads',
        value: (current.audioAdPartnerIds && current.audioAdPartnerIds.length) || 0
      })
      this.mainFields.push({
        label: 'Tags' + ` (${(current.tagsPartner && current.tagsPartner.length) || 0})`,
        value: (current.tagsPartner && current.tagsPartner.length) ? this.getTags(current) : Helper.getString('unknown')
      })
    }

    // Orientation (always)
    this.mainFields.push({
      label: 'Orientation',
      value: current._ORIENTATION || 'UNKNOWN'
    })

    // (PARTNER ONLY) Disp Campaigns, Disp Ads
    if (this.orgType === 'PARTNER') {
      this.mainFields.push({
        label: 'Disp Campaigns',
        value: (current.campaignsPartner && current.campaignsPartner.length) || 0
      })
      // this.mainFields.push({
      //   label: 'Disp Ads',
      //   value: (current.imageAdPartnerIds && current.imageAdPartnerIds.length) || 0
      // })
    } else {
      // For non-partner, you could include generic campaigns/ads here if needed.
    }

    // STATUS FIELDS
    // Status (Venue Status)
    const status = (current.latestDeviceFeed && current.latestDeviceFeed.currentTs) ?
      AppHelper.getVenueStatus(Helper.currentTs() - current.latestDeviceFeed.currentTs)
      : AppHelper.offlineStatus()
    if (status) {
      this.mainFields.push({
        label: 'Status',
        value: status || Helper.getString('unknown')
      })
    }

    // Signal Status
    if(AppUiHelper.getVenueSignalStatus(current)) {
      this.mainFields.push({
        label: 'Signal Status',
        value: AppUiHelper.getVenueSignalStatus(current)
      })
    }

    // Sync Info
    if(AppHelper.getSyncInfo(current)) {
      this.mainFields.push({
        label: 'Sync Info',
        value: AppHelper.getSyncInfo(current)
      })
    }

    // HDMI Info
    if(AppHelper.getHdmiInfo(current)) {
      this.mainFields.push({
        label: 'HDMI Info',
        value: AppHelper.getHdmiInfo(current)
      })
    }
  }

  addSiteInfoFields(current) {
    if (!current.site) return
    if (current.site.title) {
      this.mainFields.push({
        label: 'Store Name',
        value: <span className={css(Styles.storeNameText)}>{current.site.title}</span>
      })
    }
    if (current.site.address) {
      this.mainFields.push({
        label: 'Store Address',
        value: current.site.address
      })
    }
  }

  getTags(current) {
    if (!current.tagsPartner || !current.tagsPartner.length) return null;

    return (
      <div className={css(Styles.tagHolder)}>
        {AppHelper.getTagChips(current.tagsPartner, this.state.tags).map((x, i) => (
          <Chip key={'chip_' + i} label={x} size='small' className={css(Styles.tagChip)} />
        ))}
      </div>
    );
  }

  onActions = () => [];

  renderAboveTable() {
    return (
      <div className={css(Styles.taskDetailsComponents)}>

        {/* Component */}
        <div className={css(Styles.taskInfoBlock)}>
          <SubEntityCustomListCard
            renderFieldsRowwise={true}
            title={'Info'}
            formDefinition={this.formDefinition || {}}
            item={this.venueItem || {}}
            openModalForEdit={(current) => {
              this.openModalForEdit(current, this.formDefinition)
            }}
            mainFields={this.mainFields}
          />
        </div>
        <div className={css(Styles.subTaskInfoBlock)}>
          <SubEntityList
            title={Helper.getString('deviceHistory')}
            tableHeadersMap={this.tableHeadersMap}
            items={this.state.deviceHistory.items || []}
            noAdd={this.noAddSubEntity}
            subEntityActions={this.onActions}
            tableContainer={{
              padding: 0
            }}
          />
        </div>
      </div>
    )
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {},
      apiEndPoint: ApiHelper.makeUrlPath(['devices', this.deviceId]),
    });
  }

}
const Styles = StyleSheet.create({
  allValues: {
    maxWidth: 400
  },
  eachValue: {
    maxWidth: '100%',
    lineBreak: 'anywhere',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 12
  },
  taskDetailsComponents: {
    flex: 1
  },
  taskInfoBlock: {
    marginBottom: 20
  },
  subTaskInfoBlock: {
    marginBottom: 20
  },

  tagHolder: {
    maxWidth: 400,
    marginTop: 4
  },
  storeNameText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  tagChip: {
    marginRight: 6,
    marginBottom: 6,
    maxWidth: 300,
    background: 'rgba(87, 87, 87, 0.1)',
    borderRadius: 17,
    color: 'rgba(87, 87, 87, 1)',
    fontSize: 14,
    padding: '16px 4px'
  },
  commentStyle: {
    maxWidth: 400,
    whiteSpace: 'pre-line'
  }
})



// WEBPACK FOOTER //
// ./src/screens/admin/Venue.js